import { render, staticRenderFns } from "./customField.vue?vue&type=template&id=ff1227f2&scoped=true&"
import script from "./customField.vue?vue&type=script&lang=js&"
export * from "./customField.vue?vue&type=script&lang=js&"
import style0 from "./customField.vue?vue&type=style&index=0&id=ff1227f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1227f2",
  null
  
)

export default component.exports